import { RestartAltOutlined, WidthFullOutlined } from '@mui/icons-material';
import { IconButton, Tooltip, Typography } from '@mui/material';
import { isNotNil } from 'ramda';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { I18nNamespace } from '@/legacy/common/types';
import { useConversationContext } from '@/legacy/components/ConversationContextProvider/ConversationContextProvider.hook';
import { DrawerHeader } from '@/legacy/components/ResizeableDrawer/components/DrawerHeader/DrawerHeader';
import { OpenCloseProps } from '@/legacy/hooks';
import { ThreadVariant } from '@/legacy/routes/experiments/Cockpit/Cockpit.types';
import { variantRouteMapping } from '@/legacy/routes/experiments/Cockpit/components/CockpitContextProvider/CockpitContextProvider.utils';

export const DemandConversationDrawerHeader = ({ onClose }: Pick<OpenCloseProps, 'onClose'>) => {
  const { t } = useTranslation(I18nNamespace.conversation, { keyPrefix: 'DemandConversation' });
  const navigate = useNavigate();

  const { status, reset, entityId } = useConversationContext();

  return (
    <DrawerHeader
      title={<Typography variant="h6">{t('title')}</Typography>}
      actions={
        <>
          <Tooltip title={t('action.reset')}>
            <IconButton disabled={status === 'loading'} onClick={reset}>
              <RestartAltOutlined />
            </IconButton>
          </Tooltip>
          <Tooltip title={t('action.openInCockpit')}>
            <IconButton
              disabled={status === 'loading'}
              onClick={() => isNotNil(entityId) && navigate(variantRouteMapping[ThreadVariant.SOURCING](entityId))}
            >
              <WidthFullOutlined />
            </IconButton>
          </Tooltip>
        </>
      }
      onClose={onClose}
    />
  );
};
